import { useNavigatePreserveQuery } from "lib/hooks/useNavigatePreserveQuery";

const withTradeRowItem = (Component: React.ComponentType<any>) => {
  return ({ tradeCall }: { tradeCall: any }) => {
    const { chain, tokenAddress, tgGroupId } = tradeCall;

    const navigate = useNavigatePreserveQuery();

    const navigateToTokenDetailPage = () => {
      navigate({
        pathname: `/token/${tokenAddress}`,
        search: `from=trade&chain=${chain}${tgGroupId ? `&groupId=${tgGroupId}` : ""}`,
      });
    };

    return <Component tradeCall={tradeCall} navigateTo={navigateToTokenDetailPage} />;
  };
};

export default withTradeRowItem;
